module.exports = __webpack_public_path__ + "img/academy_team_dev-sm.c0f9a0e1.png";